import RoutesMap from '../../route_control/RouteControl'
import Logo from '../../assets/images/wrric.png'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPinterestP } from 'react-icons/fa'
import { Globe, Mail, MapPin, PhoneCall } from 'lucide-react'
import gallery_1 from '../../assets/images/about-img11.png'
import gallery_2 from '../../assets/images/about-img12.png'
import gallery_3 from '../../assets/images/about-img13.png'
import { Link } from 'react-router-dom'

export const FooterImport = {
    RoutesMap,
    Logo,
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaPinterestP,
    Globe,
    Mail,
    MapPin,
    PhoneCall,
    gallery_1,
    gallery_2,
    gallery_3,
    Link,
}